import { DataGrid, GridToolbar, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import { IconButton, Typography, Grid, Tooltip } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const CustomDataGrid = ({
    rows,
    columns,
    pageSizeOptions = [25, 50, 100],
    defaultPageSize = 25,
    checkboxSelection = false,
    onSelectionModelChange = () => { },
    onExportClick = () => { },
    getRowClassName = () => "",
}) => {
    const [pageSize, setPageSize] = useState(defaultPageSize);
    const [visibleRows, setVisibleRows] = useState(rows);

    // Keep visibleRows in sync
    useEffect(() => {
        setVisibleRows(rows);
    }, [rows]);

    const handleFilterChange = (filterModel) => {
        if (!filterModel.items.length) {
            setVisibleRows(rows);
            return;
        }

        const filtered = rows.filter((row) =>
            filterModel.items.every((filter) => {
                if (!filter.value) return true;
                const cellValue = row[filter.columnField];
                return String(cellValue ?? '')
                    .toLowerCase()
                    .includes(filter.value.toLowerCase());
            })
        );

        setVisibleRows(filtered);
    };

    const handleExport = () => {
        onExportClick(visibleRows);
    };
    const CustomToolbar = () => (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Grid>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <Tooltip title="Export To Excel" >

                    <IconButton onClick={handleExport} aria-label="export data" sx={{
                    '&:hover': { boxShadow: 'none', backgroundColor: 'transparent', }
                }} >
                    <FileDownloadOutlinedIcon sx={{ color: '#795548', width: 18, height: 18 }} />
                    <Typography
                        variant="body2"
                        sx={{ ml: 1, fontWeight: 500, color: '#795548' }}
                    >
                        Export
                    </Typography>
                    </IconButton>
                </Tooltip>
            </Grid>
        </div>
    );

    return (
        <div style={{ height: '66vh', width: '100%' }}>
            <DataGrid
                rows={rows}
                columns={columns}
                density="compact"
                getRowId={(row) => rows.indexOf(row)}
                components={{
                    Toolbar: CustomToolbar,
                }}
                pagination
                paginationMode="client"
                getRowHeight={() => 'auto'}
                rowsPerPageOptions={pageSizeOptions}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                checkboxSelection={checkboxSelection}
                onSelectionModelChange={onSelectionModelChange}
                getRowClassName={(params) =>
                    params.row.ColorCode ? `row-color-${params.row.ID}` : ''
                }
                onFilterModelChange={handleFilterChange}
            />
            <style>
                {rows
                    .map(
                        (row) =>
                            `.row-color-${row.ID} { background-color: ${row.ColorCode} !important; }`
                    )
                    .join('\n')}
            </style>
        </div>
    );
};

export default CustomDataGrid;
